import { IEventListPayloadItem } from '@/models/Display/Event/interfaces/IDisplayEventListPayload';
import StoreService from '@/services/StoreService';
import { action, observable } from 'mobx';
import { concat, identity } from 'ramda';
import { createContext } from 'react';
import DisplayEventActions from '@/models/Display/Event/DisplayEventActions';
import DisplayEventRequestBuilder from '@/models/Display/Event/DisplayEventRequestBuilder';
import { EventTabId } from '@/models/Display/Event/interfaces/IDisplayEventListRequestParams';

export default class EventCastStore {
  @observable page: number = 1;
  @observable list: IEventListPayloadItem[];
  @observable isLoading: boolean = false;
  @observable isEndReached: boolean = false;
  @observable errorMessage: string;
  @observable isOpenErrorPopup: boolean = false;
  @observable tabId: EventTabId = 'promotionWideBannerSwipe';

  private readonly limit = 20;
  private readonly storedListKey: string;
  private readonly storedSequenceKey: string;
  private readonly actions = new DisplayEventActions(DisplayEventRequestBuilder);
  private readonly sessionStore = StoreService.getInstance('session');

  constructor({
    list,
    restoreData = false,
    tabId,
  }: {
    list: IEventListPayloadItem[];
    restoreData?: boolean;
    tabId: EventTabId;
  }) {
    this.storedListKey = `${tabId}/list`;
    this.storedSequenceKey = `${tabId}/sequence`;
    this.tabId = tabId;

    const storedData = this.sessionStore.get(this.storedListKey);
    if (restoreData && storedData) {
      const storedSequence = this.sessionStore.get(this.storedSequenceKey);
      this.list = storedData;
      this.page = storedSequence;
    } else {
      this.list = list;
    }
    this.page = 1;
  }

  @action
  addPage(): void {
    this.page += 1;
  }

  @action.bound
  closeErrorPopup(): void {
    this.isOpenErrorPopup = false;
  }

  @action.bound
  async onLoad(): Promise<void> {
    if (this.isLoading || this.isEndReached) {
      return;
    }
    // 페이징 없음
    if (this.tabId === 'promotionWideBannerSwipe') {
      this.isEndReached = true;
      return;
    }

    this.addPage();
    this.isLoading = true;

    const { tabId, limit, page } = this;
    const eventEntity = await this.actions.list({ query: { tabId, limit, page } });
    const list = eventEntity
      .map((response) => response.data || [])
      .caseOf<void | IEventListPayloadItem[]>({
        left: (error) => {
          console.error(error);
          this.errorMessage = '오류가 발생했습니다';
          this.isOpenErrorPopup = true;
        },
        right: identity,
      });

    this.isLoading = false;

    if (!list) {
      return;
    }

    if (Array.isArray(list) && list.length) {
      this.list = concat(this.list, list);
      this.sessionStore.set(this.storedListKey, this.list);
      this.sessionStore.set(this.storedSequenceKey, this.page);
    } else {
      this.isEndReached = true;
    }
  }
}

export const EventCastStoreCtx = createContext(new EventCastStore({ list: [], tabId: 'promotionWideBannerSwipe' }));
